import { createActions } from "@thewebops/admin-panel";

const actions = {
  downloadDeleteTemplate: createActions(`product/downloadDeleteTemplate`),
};

export default actions;
